(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
if (document.readyState === 'loading') {
  console.log('Customer Review IF');
} else {
  console.log('Customer Review ELSE');
  console.log('Customer Reviews Section Loaded');
  
  // Swiper initialization function
  function initializeSwipers() {
    console.log('Initializing Swipers...');
    const isDesktop = () => window.innerWidth > 767.9;
    let gap = 16;
    const sliders = [];

    ["#horizontal-ticker-rtl", "#horizontal-ticker-ltr"].forEach((query, index) => {
      const sliderElement = document.querySelector(query);
      if (sliderElement && sliderElement.querySelector('.swiper-slide')) {
        const swiper = new Swiper(query, {
          loop: true,
          slidesPerView: isDesktop() ? 2.5 : 1.2,
          spaceBetween: gap,
          speed: 8000,
          allowTouchMove: false,
          autoplay: {
            delay: 0,
            reverseDirection: index === 1,
            disableOnInteraction: false, // Keep autoplay running even after user interaction
            pauseOnMouseEnter: true, // Pause autoplay on mouse enter, resume on mouse leave
          }
        });
        
        sliders.push(swiper);
        console.log(`Swiper initialized for: ${query}`);
      } else {
        console.log(`No slides found for: ${query}`);
      }
    });
    

    window.addEventListener("resize", () => {
      sliders.forEach((slider) => {
        slider.params.slidesPerView = isDesktop() ? 2.5 : 1.2;
        slider.params.spaceBetween = gap;
        slider.update();
      });
    });
  }

  // Function to truncate text to 130 characters
  function truncateText(text, maxLength = 130) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }

  // Function to create star rating HTML
  function createStarRating(rating) {
    const maxStars = 5;
    const filledStars = Math.round(rating);
    const emptyStars = maxStars - filledStars;
    
    let starsHTML = '';
    
    for (let i = 0; i < filledStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    return `<div class="star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
  }

  // Function to initialize Bootstrap popovers
  function initializePopovers() {
    // Wait for Bootstrap to load
    if (typeof bootstrap !== 'undefined') {
      const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
      const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, {
        trigger: 'hover',
        placement: 'top',
        html: true,
        container: 'body'
      }));
      console.log('Popovers initialized:', popoverList.length);
    } else {
      // Retry if Bootstrap not loaded yet
      setTimeout(initializePopovers, 100);
    }
  }

  // Function to create review HTML with truncated text and popover
  function createReviewHTML(review, isRightSlider = false) {
    // console.log('Creating review HTML for:', review.authorName);
    
    const authorImage = review.authorPhotoUrl || '';
    const rating = review.rating || 5;
    const fullContent = review.originalText || '';
    const truncatedContent = truncateText(fullContent, 130);
    const authorName = review.authorName || 'Anonymous';
    const reviewCount = review.authorDetail || '';

    // Check if text needs truncation
    const needsTruncation = fullContent.length > 130;
    const displayContent = needsTruncation ? truncatedContent : fullContent;

    return `
      <div class="swiper-slide horizontal-ticker__slide">
        <div class="customer-review">
          <div class="customer-review-inner">
            ${authorImage ? `
              <div class="customer-author-img">
                <img src="${authorImage}" alt="${authorName}" loading="lazy" >
              </div>
            ` : `
              <div class="customer-author-img" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
                <span style="font-size: 24px;">👤</span>
              </div>
            `}
            <div style="flex: 1;">
              <div class="hidecustomer-rating">
                ${createStarRating(rating)}
              </div>
              ${displayContent ? `
                <div class="customer-review-text">
                  <p 
                    ${needsTruncation ? `data-bs-toggle="popover" 
                     data-bs-title="${authorName}" 
                     data-bs-content="${fullContent.replace(/"/g, '&quot;')}" 
                     data-bs-custom-class="review-popover"` : ''}
                     style="cursor: ${needsTruncation ? 'pointer' : 'default'}; margin: 0;"
                  >
                    ${displayContent}
                  </p>
                </div>
              ` : ''}
              <div class="customer-footer">
                <div class="customer-rating-container">
                  <div class="customer-rating">
                    ${createStarRating(rating)}
                  </div>
                  <p class="customer-author-name">${authorName}</p>
                </div>
                <div class="customer-verify">
                  <span class="customer-verify-text">Verified Customer</span>
                  ${reviewCount ? `<span class="customer-review-count">${reviewCount}</span>` : ''}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // Function to populate reviews from _appioGoogleReviewsData
  function populateReviewsFromData() {
    console.log('Checking for _appioGoogleReviewsData...');
    
    if (typeof _appioGoogleReviewsData !== 'undefined' && _appioGoogleReviewsData && _appioGoogleReviewsData.reviews) {
      console.log('_appioGoogleReviewsData found');
      
      const reviews = _appioGoogleReviewsData.reviews;
      console.log('Total reviews found:', reviews.length);
      
      // Split reviews into two halves
      const halfIndex = Math.ceil(reviews.length / 2);
      const firstHalfReviews = reviews.slice(0, halfIndex);
      const secondHalfReviews = reviews.slice(halfIndex);
      
      // Get slider containers
      const rtlSlider = document.querySelector('#horizontal-ticker-rtl .swiper-wrapper');
      const ltrSlider = document.querySelector('#horizontal-ticker-ltr .swiper-wrapper');
      
      // Clear existing content
      if (rtlSlider) rtlSlider.innerHTML = '';
      if (ltrSlider) ltrSlider.innerHTML = '';
      
      // Populate first slider (RTL) with first half of reviews
      if (firstHalfReviews.length > 0) {
        firstHalfReviews.forEach((review, index) => {
          const reviewHTML = createReviewHTML(review, false);
          if (rtlSlider) {
            rtlSlider.innerHTML += reviewHTML;
          }
        });
      }
      
      // Populate second slider (LTR) with second half of reviews
      if (secondHalfReviews.length > 0) {
        secondHalfReviews.forEach((review, index) => {
          const reviewHTML = createReviewHTML(review, true);
          if (ltrSlider) {
            ltrSlider.innerHTML += reviewHTML;
          }
        });
      }
      
      console.log('Reviews populated successfully');
      
      // Initialize swipers after populating reviews
      setTimeout(() => {
        initializeSwipers();
        initializePopovers();
      }, 500);
      
    } else {
      console.warn('_appioGoogleReviewsData not found or invalid');
      initializeSwipers();
    }
  }

  // Call the function to populate reviews
  populateReviewsFromData();

  // Rest of your existing code...
  console.log('Checking for H1 to H2 conversion...');
  var intervalId = setInterval(function() {
    var h1 = document.querySelector("#reviews h1");
    if (h1) {
      var h2 = document.createElement("h2");
      h2.innerHTML = h1.innerHTML;
      h2.className = h1.className + " h1";
      h1.parentNode.replaceChild(h2, h1);
      console.log('H1 converted to H2');
      clearInterval(intervalId);
    }
  }, 300);

  // Sticky ATC observer
  console.log('Setting up sticky ATC observer...');
  const targetNode = document.getElementById('sticky-atc');
  
  if (targetNode) {
    const config = { attributes: true, attributeFilter: ['class'] };
    const callback = function(mutationsList, observer) {
      for(const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const shopifyChat = document.getElementById('ShopifyChat');
          const smileLauncher = document.getElementById('smile-ui-lite-launcher-frame-container');
          
          if (targetNode.classList.contains('show')) {
            if (shopifyChat) shopifyChat.style.bottom = '80px';
            if (smileLauncher) smileLauncher.style.bottom = '90px';
          } else {
            if (shopifyChat) shopifyChat.style.bottom = '16px';
            if (smileLauncher) smileLauncher.style.bottom = '25px';
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  console.log('Customer Reviews section initialization completed');
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    

// Hero Banner Dynamic Review Code
console.log('🚀 Hero Banner Script Loading...');

// Add Bootstrap CSS and JS dynamically
function loadBootstrap() {
  // Check if Bootstrap CSS is already loaded
  if (!document.querySelector('link[href*="bootstrap"]')) {
    const bootstrapCSS = document.createElement('link');
    bootstrapCSS.rel = 'stylesheet';
    bootstrapCSS.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
    document.head.appendChild(bootstrapCSS);
  }

  // Check if Bootstrap JS is already loaded
  if (!document.querySelector('script[src*="bootstrap"]')) {
    const bootstrapJS = document.createElement('script');
    bootstrapJS.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js';
    bootstrapJS.onload = initializeHeroBannerReview;
    document.head.appendChild(bootstrapJS);
  } else {
    initializeHeroBannerReview();
  }
}

var reviewEle = document.querySelector('.full-review');

const reviewId = reviewEle.getAttribute('data-review_id');
const manual_author_name = reviewEle.getAttribute('data-manual_author_name');
const manual_review_text = reviewEle.getAttribute('data-manual_review_text');
const manual_rating = reviewEle.getAttribute('data-manual_rating');
const manual_review_link = reviewEle.getAttribute('data-manual_review_link');
const manual_author_image = reviewEle.getAttribute('data-manual_author_image');

function initializeHeroBannerReview() {
  console.log('🚀 Initializing Hero Banner Dynamic Review...');
  
  const fullReviewContainer = document.querySelector('.full-review');
  if (!fullReviewContainer) {
    console.log('❌ Full review container not found');
    return;
  }
  
  // Check if manual review data is available in section settings
  const manualAuthorName = manual_author_name;
  console.log('const manualAuthorName = ', manual_author_name);
  const manualReviewText = manual_review_text;
  const manualRating = parseInt(manual_rating) || 5;
  const manualReviewLink = manual_review_link;
  const manualAuthorImage = manual_author_image;

  
  // If manual data is provided, use it
  if (manualAuthorName && manualReviewText) {
    console.log('✅ Using manual review data');
    populateManualReview({
      authorName: manualAuthorName,
      reviewText: manualReviewText,
      rating: manualRating,
      reviewLink: manualReviewLink,
      authorImage: manualAuthorImage
    });
    return;
  }
  
  // Otherwise try to get from _appioGoogleReviewsData
  const reviewEle = document.querySelector('.full-review');
  const reviewId = reviewEle ? reviewEle.getAttribute('data-review_id') : null;
  console.log('Looking for Review ID:', reviewId);
  
  if (!reviewId || reviewId === '') {
    console.log('❌ No Review ID found in section settings');
    showDefaultReview();
    return;
  }
  
  // Wait for _appioGoogleReviewsData to be available
  function checkDataAndInitialize() {
    if (typeof _appioGoogleReviewsData !== 'undefined' && _appioGoogleReviewsData && _appioGoogleReviewsData.reviews) {
      console.log('✅ _appioGoogleReviewsData found');
      
      const reviews = _appioGoogleReviewsData.reviews;
      console.log('Total reviews available:', reviews.length);
      console.log('All reviews:', reviews.map(r => ({ id: r.id, reviewId: r.reviewId, author: r.authorName })));
      
      // Find the specific review by ID
      const targetReview = reviews.find(review => 
        review.id == reviewId || 
        review.reviewId === reviewId ||
        review.id.toString() === reviewId.toString()
      );
      
      if (targetReview) {
        console.log('✅ Target review found:', targetReview.authorName);
        populateDynamicReview(targetReview);
      } else {
        console.log('❌ Review not found with ID:', reviewId);
        showDefaultReview();
      }
    } else {
      console.log('⏳ _appioGoogleReviewsData not available yet, retrying...');
      setTimeout(checkDataAndInitialize, 500);
    }
  }
  
  checkDataAndInitialize();
}

// Function to initialize Bootstrap popovers
function initializePopovers() {
  // Wait for Bootstrap to be available
  if (typeof bootstrap !== 'undefined') {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
      return new bootstrap.Popover(popoverTriggerEl, {
        trigger: 'hover',
        placement: 'top',
        html: true,
        container: 'body',
        customClass: 'review-popover'
      });
    });
    console.log('✅ Popovers initialized:', popoverList.length);
  } else {
    // Retry if Bootstrap not loaded yet
    setTimeout(initializePopovers, 100);
  }
}

// Function to populate manual review
function populateManualReview(manualData) {
  console.log('🎯 Populating manual review:', manualData.authorName);
  
  const fullReviewContainer = document.querySelector('.full-review');
  if (!fullReviewContainer) return;
  
  // Create star rating HTML
  function createStarRating(rating) {
    const maxStars = 5;
    const filledStars = Math.round(rating);
    const emptyStars = maxStars - filledStars;
    
    let starsHTML = '';
    
    for (let i = 0; i < filledStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    return `<div class="star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
  }
  
  // Function to truncate text to 130 characters
  function truncateText(text, maxLength = 130) {
    // Remove HTML tags for truncation
    const cleanText = text.replace(/<[^>]*>/g, '');
    if (cleanText.length <= maxLength) return cleanText;
    return cleanText.substring(0, maxLength) + '...';
  }
  
  const fullContent = manualData.reviewText.replace(/<[^>]*>/g, '');
  const truncatedContent = truncateText(fullContent, 130);
  const needsTruncation = fullContent.length > 130;
  const displayContent = needsTruncation ? truncatedContent : fullContent;
  
  const reviewHTML = `
    ${manualData.authorImage && manualData.authorImage !== '' ? `
      <div class="author_icon">
        <img 
          src="${manualData.authorImage}" 
          alt="${manualData.authorName}" 
          class="author_image" 
          onerror="this.style.display='none';" 
        >
      </div>
    ` : `
      <div class="author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
        <span style="font-size: 20px;">👤</span>
      </div>
    `}
    <div class="dtf-cus-review-txt-wrap">
      
      ${displayContent ? `
        <div class="full-review-content">
          <p
            ${needsTruncation ? `data-bs-toggle="popover" 
                     data-bs-title="${manualData.authorName}" 
                     data-bs-content="${fullContent.replace(/"/g, '&quot;')}"` : ''}
            style="cursor: ${needsTruncation ? 'pointer' : 'default'}; margin: 0;"
          >${displayContent}</p>
        </div>
      ` : ''}
      <div class="author_rating_main">
        <div class="author_rating_content">
          ${createStarRating(manualData.rating || 5)}
          <p class="author-name">${manualData.authorName || 'Happy Customer'}</p>
        </div>
        <div class="verify-info">
          ${manualData.reviewLink ? `
            <a href="${manualData.reviewLink}" target="_blank" style="text-decoration: none;">
              <span class="verify-content">Verified Customer</span>
            </a>
          ` : `
            <span class="verify-content">Verified Customer</span>
          `}
        </div>
      </div>
    </div>
  `;
  
  fullReviewContainer.innerHTML = reviewHTML;
  
  // Initialize popovers after content is added
  setTimeout(initializePopovers, 100);
  console.log('✅ Manual review updated successfully');
}

// Function to populate dynamic review from _appioGoogleReviewsData
function populateDynamicReview(review) {
  console.log('🎯 Populating dynamic review:', review.authorName);
  
  const fullReviewContainer = document.querySelector('.full-review');
  if (!fullReviewContainer) return;
  
  // Create star rating HTML
  function createStarRating(rating) {
    const maxStars = 5;
    const filledStars = Math.round(rating);
    const emptyStars = maxStars - filledStars;
    
    let starsHTML = '';
    
    for (let i = 0; i < filledStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    return `<div class="star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
  }
  
  // Function to truncate text to 130 characters
  function truncateText(text, maxLength = 130) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }
  
  const fullContent = review.originalText || '';
  const truncatedContent = truncateText(fullContent, 130);
  const needsTruncation = fullContent.length > 130;
  const displayContent = needsTruncation ? truncatedContent : fullContent;
  
  const reviewHTML = `
    ${review.authorPhotoUrl ? `
      <div class="author_icon">
        <img 
          src="${review.authorPhotoUrl}" 
          alt="${review.authorName}" 
          class="author_image" 
          onerror="this.style.display='none';" 
        >
      </div>
    ` : `
      <div class="author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
        <span style="font-size: 20px;">👤</span>
      </div>
    `}
    <div>
      <div class="hide_rating_icon">
        ${createStarRating(review.rating || 5)}
      </div>
      ${displayContent ? `
        <div class="full-review-content">
          <p
            ${needsTruncation ? `data-bs-toggle="popover" 
                     data-bs-title="${review.authorName}" 
                     data-bs-content="${fullContent.replace(/"/g, '&quot;')}"` : ''}
            style="cursor: ${needsTruncation ? 'pointer' : 'default'}; margin: 0;"
          >${displayContent}</p>
        </div>
      ` : ''}
      <div class="author_rating_main">
        <div class="author_rating_content">
          ${createStarRating(review.rating || 5)}
          <p class="author-name">${review.authorName || 'Happy Customer'}</p>
        </div>
        <div class="verify-info">
          ${review.reviewUrl ? `
            <a href="${review.reviewUrl}" target="_blank" style="text-decoration: none;">
              <span class="verify-content">Verified Customer</span>
            </a>
          ` : `
            <span class="verify-content">Verified Customer</span>
          `}
        </div>
      </div>
    </div>
  `;
  
  fullReviewContainer.innerHTML = reviewHTML;
  
  // Initialize popovers after content is added
  setTimeout(initializePopovers, 100);
  console.log('✅ Dynamic review updated successfully');
}

// Function to show default review
function showDefaultReview() {
  const fullReviewContainer = document.querySelector('.full-review');
  if (!fullReviewContainer) return;
  
  fullReviewContainer.innerHTML = `
    <div class="author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
      <span style="font-size: 20px;">👤</span>
    </div>
    <div>
      <div class="hide_rating_icon">
        <div class="star-rating" style="display: flex; gap: 2px; align-items: center;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
      </div>
      <div class="full-review-content">
        <p>Excellent product and service!</p>
      </div>
      <div class="author_rating_main">
        <div class="author_rating_content">
          <div class="star-rating" style="display: flex; gap: 2px; align-items: center;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <p class="author-name">Happy Customer</p>
        </div>
        <div class="verify-info">
          <span class="verify-content">Verified Customer</span>
        </div>
      </div>
    </div>
  `;
}

// Start the process
loadBootstrap();
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["last-hero-banner"] && !Shopify.designMode) return;
  try {
    

// Last Hero Banner Dynamic Review Code
console.log('🚀 Last Hero Banner Script Loading...');

// Add Bootstrap CSS and JS dynamically for Last Hero Banner
function loadBootstrapForLastHero() {
  // Check if Bootstrap CSS is already loaded
  if (!document.querySelector('link[href*="bootstrap"]')) {
    const bootstrapCSS = document.createElement('link');
    bootstrapCSS.rel = 'stylesheet';
    bootstrapCSS.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
    document.head.appendChild(bootstrapCSS);
  }

  // Check if Bootstrap JS is already loaded
  if (!document.querySelector('script[src*="bootstrap"]')) {
    const bootstrapJS = document.createElement('script');
    bootstrapJS.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js';
    bootstrapJS.onload = initializeLastHeroBannerReview;
    document.head.appendChild(bootstrapJS);
  } else {
    initializeLastHeroBannerReview();
  }
}

var lastReviewEle = document.querySelector('.last-full-review');

const lastReviewId = lastReviewEle ? lastReviewEle.getAttribute('data-review_id') : null;
const lastManualAuthorName = lastReviewEle ? lastReviewEle.getAttribute('data-manual_author_name') : null;
const lastManualReviewText = lastReviewEle ? lastReviewEle.getAttribute('data-manual_review_text') : null;
const lastManualRating = lastReviewEle ? lastReviewEle.getAttribute('data-manual_rating') : null;
const lastManualReviewLink = lastReviewEle ? lastReviewEle.getAttribute('data-manual_review_link') : null;
const lastManualAuthorImage = lastReviewEle ? lastReviewEle.getAttribute('data-manual_author_image') : null;

function initializeLastHeroBannerReview() {
  console.log('🚀 Initializing Last Hero Banner Dynamic Review...');
  
  const lastFullReviewContainer = document.querySelector('.last-full-review');
  if (!lastFullReviewContainer) {
    console.log('❌ Last full review container not found');
    return;
  }
  
  // Check if manual review data is available in section settings
  const manualAuthorName = lastManualAuthorName;
  console.log('Last Hero - const manualAuthorName = ', manualAuthorName);
  const manualReviewText = lastManualReviewText;
  const manualRating = parseInt(lastManualRating) || 5;
  const manualReviewLink = lastManualReviewLink;
  const manualAuthorImage = lastManualAuthorImage;

  
  // If manual data is provided, use it
  if (manualAuthorName && manualReviewText) {
    console.log('✅ Using manual review data for Last Hero');
    populateLastManualReview({
      authorName: manualAuthorName,
      reviewText: manualReviewText,
      rating: manualRating,
      reviewLink: manualReviewLink,
      authorImage: manualAuthorImage
    });
    return;
  }
  
  // Otherwise try to get from _appioGoogleReviewsData
  const reviewId = lastReviewId;
  console.log('Last Hero - Looking for Review ID:', reviewId);
  
  if (!reviewId || reviewId === '') {
    console.log('❌ No Review ID found in Last Hero section settings');
    showLastDefaultReview();
    return;
  }
  
  // Wait for _appioGoogleReviewsData to be available
  function checkDataAndInitialize() {
    if (typeof _appioGoogleReviewsData !== 'undefined' && _appioGoogleReviewsData && _appioGoogleReviewsData.reviews) {
      console.log('✅ _appioGoogleReviewsData found for Last Hero');
      
      const reviews = _appioGoogleReviewsData.reviews;
      console.log('Last Hero - Total reviews available:', reviews.length);
      
      // Find the specific review by ID
      const targetReview = reviews.find(review => 
        review.id == reviewId || 
        review.reviewId === reviewId ||
        review.id.toString() === reviewId.toString()
      );
      
      if (targetReview) {
        console.log('✅ Target review found for Last Hero:', targetReview.authorName);
        populateLastDynamicReview(targetReview);
      } else {
        console.log('❌ Review not found with ID:', reviewId);
        showLastDefaultReview();
      }
    } else {
      console.log('⏳ _appioGoogleReviewsData not available yet for Last Hero, retrying...');
      setTimeout(checkDataAndInitialize, 500);
    }
  }
  
  checkDataAndInitialize();
}

// Function to initialize Bootstrap popovers for Last Hero
function initializeLastPopovers() {
  // Wait for Bootstrap to be available
  if (typeof bootstrap !== 'undefined') {
    const popoverTriggerList = document.querySelectorAll('.last-full-review [data-bs-toggle="popover"]');
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
      return new bootstrap.Popover(popoverTriggerEl, {
        trigger: 'hover',
        placement: 'top',
        html: true,
        container: 'body',
        customClass: 'review-popover'
      });
    });
    console.log('✅ Last Hero Popovers initialized:', popoverList.length);
  } else {
    // Retry if Bootstrap not loaded yet
    setTimeout(initializeLastPopovers, 100);
  }
}

// Function to populate manual review for Last Hero
function populateLastManualReview(manualData) {
  console.log('🎯 Populating Last Hero manual review:', manualData.authorName);
  
  const lastFullReviewContainer = document.querySelector('.last-full-review');
  if (!lastFullReviewContainer) return;
  
  // Create star rating HTML
  function createStarRating(rating) {
    const maxStars = 5;
    const filledStars = Math.round(rating);
    const emptyStars = maxStars - filledStars;
    
    let starsHTML = '';
    
    for (let i = 0; i < filledStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    return `<div class="last-star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
  }
  
  // Function to truncate text to 130 characters
  function truncateText(text, maxLength = 130) {
    // Remove HTML tags for truncation
    const cleanText = text.replace(/<[^>]*>/g, '');
    if (cleanText.length <= maxLength) return cleanText;
    return cleanText.substring(0, maxLength) + '...';
  }
  
  const fullContent = manualData.reviewText.replace(/<[^>]*>/g, '');
  const truncatedContent = truncateText(fullContent, 130);
  const needsTruncation = fullContent.length > 130;
  const displayContent = needsTruncation ? truncatedContent : fullContent;
  
  const reviewHTML = `
    ${manualData.authorImage && manualData.authorImage !== '' ? `
      <div class="last-author_icon">
        <img 
          src="${manualData.authorImage}" 
          alt="${manualData.authorName}" 
          class="last-author_image" 
          onerror="this.style.display='none';" 
        >
      </div>
    ` : `
      <div class="last-author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
        <span style="font-size: 20px;">👤</span>
      </div>
    `}
    <div>
      <div class="last-hide_rating_icon">
        ${createStarRating(manualData.rating || 5)}
      </div>
      ${displayContent ? `
        <div class="last-full-review-content">
          <p
            ${needsTruncation ? `data-bs-toggle="popover" 
                     data-bs-title="${manualData.authorName}" 
                     data-bs-content="${fullContent.replace(/"/g, '&quot;')}"` : ''}
            style="cursor: ${needsTruncation ? 'pointer' : 'default'}; margin: 0;"
          >${displayContent}</p>
        </div>
      ` : ''}
      <div class="last-author_rating_main">
        <div class="last-author_rating_content">
          ${createStarRating(manualData.rating || 5)}
          <p class="last-author-name">${manualData.authorName || 'Happy Customer'}</p>
        </div>
        <div class="last-verify-info">
          ${manualData.reviewLink ? `
            <a href="${manualData.reviewLink}" target="_blank" style="text-decoration: none;">
              <span class="last-verify-content">Verified Customer</span>
            </a>
          ` : `
            <span class="last-verify-content">Verified Customer</span>
          `}
        </div>
      </div>
    </div>
  `;
  
  lastFullReviewContainer.innerHTML = reviewHTML;
  
  // Initialize popovers after content is added
  setTimeout(initializeLastPopovers, 100);
  console.log('✅ Last Hero manual review updated successfully');
}

// Function to populate dynamic review from _appioGoogleReviewsData for Last Hero
function populateLastDynamicReview(review) {
  console.log('🎯 Populating Last Hero dynamic review:', review.authorName);
  
  const lastFullReviewContainer = document.querySelector('.last-full-review');
  if (!lastFullReviewContainer) return;
  
  // Create star rating HTML
  function createStarRating(rating) {
    const maxStars = 5;
    const filledStars = Math.round(rating);
    const emptyStars = maxStars - filledStars;
    
    let starsHTML = '';
    
    for (let i = 0; i < filledStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    for (let i = 0; i < emptyStars; i++) {
      starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
    }
    
    return `<div class="last-star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
  }
  
  // Function to truncate text to 130 characters
  function truncateText(text, maxLength = 130) {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }
  
  const fullContent = review.originalText || '';
  const truncatedContent = truncateText(fullContent, 130);
  const needsTruncation = fullContent.length > 130;
  const displayContent = needsTruncation ? truncatedContent : fullContent;
  
  const reviewHTML = `
    ${review.authorPhotoUrl ? `
      <div class="last-author_icon">
        <img 
          src="${review.authorPhotoUrl}" 
          alt="${review.authorName}" 
          class="last-author_image" 
          onerror="this.style.display='none';" 
        >
      </div>
    ` : `
      <div class="last-author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
        <span style="font-size: 20px;">👤</span>
      </div>
    `}
    <div>
      <div class="last-hide_rating_icon">
        ${createStarRating(review.rating || 5)}
      </div>
      ${displayContent ? `
        <div class="last-full-review-content">
          <p
            ${needsTruncation ? `data-bs-toggle="popover" 
                     data-bs-title="${review.authorName}" 
                     data-bs-content="${fullContent.replace(/"/g, '&quot;')}"` : ''}
            style="cursor: ${needsTruncation ? 'pointer' : 'default'}; margin: 0;"
          >${displayContent}</p>
        </div>
      ` : ''}
      <div class="last-author_rating_main">
        <div class="last-author_rating_content">
          ${createStarRating(review.rating || 5)}
          <p class="last-author-name">${review.authorName || 'Happy Customer'}</p>
        </div>
        <div class="last-verify-info">
          ${review.reviewUrl ? `
            <a href="${review.reviewUrl}" target="_blank" style="text-decoration: none;">
              <span class="last-verify-content">Verified Customer</span>
            </a>
          ` : `
            <span class="last-verify-content">Verified Customer</span>
          `}
        </div>
      </div>
    </div>
  `;
  
  lastFullReviewContainer.innerHTML = reviewHTML;
  
  // Initialize popovers after content is added
  setTimeout(initializeLastPopovers, 100);
  console.log('✅ Last Hero dynamic review updated successfully');
}

// Function to show default review for Last Hero
function showLastDefaultReview() {
  const lastFullReviewContainer = document.querySelector('.last-full-review');
  if (!lastFullReviewContainer) return;
  
  lastFullReviewContainer.innerHTML = `
    <div class="last-author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
      <span style="font-size: 20px;">👤</span>
    </div>
    <div>
      <div class="last-hide_rating_icon">
        <div class="last-star-rating" style="display: flex; gap: 2px; align-items: center;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
      </div>
      <div class="last-full-review-content">
        <p>Excellent product and service!</p>
      </div>
      <div class="last-author_rating_main">
        <div class="last-author_rating_content">
          <div class="last-star-rating" style="display: flex; gap: 2px; align-items: center;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <p class="last-author-name">Happy Customer</p>
        </div>
        <div class="last-verify-info">
          <span class="last-verify-content">Verified Customer</span>
        </div>
      </div>
    </div>
  `;
}

// Start the process for Last Hero Banner
loadBootstrapForLastHero();


// // Last Hero Banner Dynamic Review Code
// console.log('🚀 Last Hero Banner Script Loading...');

// function initializeLastHeroBannerReview() {
//   console.log('🚀 Initializing Last Hero Banner Dynamic Review...');
  
//   // Get the review ID from data attribute
//   const reviewEle = document.querySelector('.last-full-review');
//   if (!reviewEle) {
//     console.log('❌ Last full review container not found');
//     return;
//   }
  
//   const reviewId = reviewEle.getAttribute('data-review_id');
//   console.log('Looking for Review ID:', reviewId);
  
//   if (!reviewId || reviewId === '') {
//     console.log('❌ No Review ID found in section settings');
//     // Show default/fallback content if no ID
//     showDefaultLastReview();
//     return;
//   }
  
//   // Wait for _appioGoogleReviewsData to be available
//   function checkDataAndInitialize() {
//     if (typeof _appioGoogleReviewsData !== 'undefined' && _appioGoogleReviewsData && _appioGoogleReviewsData.reviews) {
//       console.log('✅ _appioGoogleReviewsData found');
      
//       const reviews = _appioGoogleReviewsData.reviews;
//       console.log('Total reviews available:', reviews.length);
//       console.log('All reviews:', reviews.map(r => ({ id: r.id, reviewId: r.reviewId, author: r.authorName })));
      
//       // Find the specific review by ID - try multiple ID fields
//       const targetReview = reviews.find(review => 
//         review.id == reviewId || 
//         review.reviewId === reviewId ||
//         review.id.toString() === reviewId.toString()
//       );
      
//       if (targetReview) {
//         console.log('✅ Target review found:', targetReview.authorName);
//         populateLastHeroReview(targetReview);
//       } else {
//         console.log('❌ Review not found with ID:', reviewId);
//         console.log('Available review IDs:', reviews.map(r => ({ id: r.id, reviewId: r.reviewId })));
//         showDefaultLastReview();
//       }
//     } else {
//       console.log('⏳ _appioGoogleReviewsData not available yet, retrying...');
//       setTimeout(checkDataAndInitialize, 500);
//     }
//   }
  
//   // Start checking for data
//   checkDataAndInitialize();
// }

// // Function to show default review content
// function showDefaultLastReview() {
//   const fullReviewContainer = document.querySelector('.last-full-review');
//   if (!fullReviewContainer) return;
  
//   fullReviewContainer.innerHTML = `
//     <div class="last-author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
//       <span style="font-size: 20px;">👤</span>
//     </div>
//     <div>
//       <div class="last-hide_rating_icon">
//         <div class="last-star-rating" style="display: flex; gap: 2px; align-items: center;">
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//             <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//           </svg>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//             <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//           </svg>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//             <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//           </svg>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//             <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//           </svg>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//             <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//           </svg>
//         </div>
//       </div>
//       <div class="last-full-review-content">
//         <p>Excellent product and service!</p>
//       </div>
//       <div class="last-author_rating_main">
//         <div class="last-author_rating_content">
//           <div class="last-star-rating" style="display: flex; gap: 2px; align-items: center;">
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//               <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//             </svg>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//               <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//             </svg>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//               <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//             </svg>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//               <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//             </svg>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//               <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//             </svg>
//           </div>
//           <p class="last-author-name">Happy Customer</p>
//         </div>
//         <div class="last-verify-info">
//           <span class="last-verify-content">Verified Customer</span>
//         </div>
//       </div>
//     </div>
//   `;
// }

// // Function to populate last hero banner review
// function populateLastHeroReview(review) {
//   console.log('🎯 Populating last hero review:', review.authorName);
  
//   const fullReviewContainer = document.querySelector('.last-full-review');
//   if (!fullReviewContainer) {
//     console.log('❌ Last full review container not found');
//     return;
//   }
  
//   // Create star rating HTML
//   function createStarRating(rating) {
//     const maxStars = 5;
//     const filledStars = Math.round(rating);
//     const emptyStars = maxStars - filledStars;
    
//     let starsHTML = '';
    
//     // Filled stars (yellow)
//     for (let i = 0; i < filledStars; i++) {
//       starsHTML += `
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
//           <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//         </svg>
//       `;
//     }
    
//     // Empty stars (gray)
//     for (let i = 0; i < emptyStars; i++) {
//       starsHTML += `
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
//           <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
//         </svg>
//       `;
//     }
    
//     return `<div class="last-star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
//   }
  
//   // Function to truncate text to 130 characters
//   function truncateText(text, maxLength = 130) {
//   if (text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + '...';
//   }


//   const fullContent = review.originalText || '';
//   const truncatedContent = truncateText(fullContent, 130);
//   // Check if text needs truncation
//   const needsTruncation = fullContent.length > 130;
//   const displayContent = needsTruncation ? truncatedContent : fullContent;

//   // Create the review HTML with last- prefixes
//   const reviewHTML = `
//     ${review.authorPhotoUrl ? `
//       <div class="last-author_icon">
//         <img 
//           src="${review.authorPhotoUrl}" 
//           alt="${review.authorName}" 
//           class="last-author_image"
//         >
//       </div>
//     ` : `
//       <div class="last-author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
//         <span style="font-size: 20px;">👤</span>
//       </div>
//     `}
//     <div>
//       <div class="last-hide_rating_icon">
//         ${createStarRating(review.rating || 5)}
//       </div>
//       ${displayContent ? `
//         <div class="full-review-content">
//           <p
//             ${needsTruncation ? `data-bs-toggle="popover" 
//                      data-bs-title="${review.authorName}" 
//                      data-bs-content="${fullContent.replace(/"/g, '&quot;')}" 
//                      data-bs-custom-class="review-popover"` : ''}
//             >${displayContent}</p>
//         </div>
//       ` : ''}
//       <div class="last-author_rating_main">
//         <div class="last-author_rating_content">
//           ${createStarRating(review.rating || 5)}
//           <p class="last-author-name">${review.authorName || 'Happy Customer'}</p>
//         </div>
//         <div class="last-verify-info">
//           <a href="${review.reviewUrl}" target="_new" style="text-decoration: none;">
//             <span class="last-verify-content">Verified Customer</span>
//             ${review.authorDetail ? `<span class="last-verify-content">${review.authorDetail}</span>` : ''}
//           </a> 
//         </div>
//       </div>
//     </div>
//   `;
  
//   // Replace the content
//   fullReviewContainer.innerHTML = reviewHTML;
//   console.log('✅ Last hero banner review updated successfully');
// }

// // Initialize immediately if data is ready, otherwise wait
// if (typeof _appioGoogleReviewsData !== 'undefined') {
//   console.log('📊 Data already available, initializing last hero banner immediately');
//   initializeLastHeroBannerReview();
// } else {
//   console.log('⏳ Waiting for data to load for last hero banner...');
//   // Try multiple initialization methods
//   document.addEventListener('DOMContentLoaded', initializeLastHeroBannerReview);
//   window.addEventListener('load', initializeLastHeroBannerReview);
  
//   // Final fallback
//   setTimeout(initializeLastHeroBannerReview, 2000);
// }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-hero-banner"] && !Shopify.designMode) return;
  try {
    
  // Hero Banner Dynamic Review Code
  console.log('🚀 Hero Banner Script Loading...');

  // Add Bootstrap CSS and JS dynamically
  function loadBootstrap() {
    // Check if Bootstrap CSS is already loaded
    if (!document.querySelector('link[href*="bootstrap"]')) {
      const bootstrapCSS = document.createElement('link');
      bootstrapCSS.rel = 'stylesheet';
      bootstrapCSS.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';
      document.head.appendChild(bootstrapCSS);
    }

    // Check if Bootstrap JS is already loaded
    if (!document.querySelector('script[src*="bootstrap"]')) {
      const bootstrapJS = document.createElement('script');
      bootstrapJS.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js';
      bootstrapJS.onload = initializeHeroBannerReview;
      document.head.appendChild(bootstrapJS);
    } else {
      initializeHeroBannerReview();
    }
  }

  var reviewEle = document.querySelector('.full-review');

  const reviewId = reviewEle.getAttribute('data-review_id');
  const manual_author_name = reviewEle.getAttribute('data-manual_author_name');
  const manual_review_text = reviewEle.getAttribute('data-manual_review_text');
  const manual_rating = reviewEle.getAttribute('data-manual_rating');
  const manual_review_link = reviewEle.getAttribute('data-manual_review_link');
  const manual_author_image = reviewEle.getAttribute('data-manual_author_image');

  function initializeHeroBannerReview() {
    console.log('🚀 Initializing Hero Banner Dynamic Review...');

    const fullReviewContainer = document.querySelector('.full-review');
    if (!fullReviewContainer) {
      console.log('❌ Full review container not found');
      return;
    }

    // Check if manual review data is available in section settings
    const manualAuthorName = manual_author_name;
    console.log('const manualAuthorName = ', manual_author_name);
    const manualReviewText = manual_review_text;
    const manualRating = parseInt(manual_rating) || 5;
    const manualReviewLink = manual_review_link;
    const manualAuthorImage = manual_author_image;

    // If manual data is provided, use it
    if (manualAuthorName && manualReviewText) {
      console.log('✅ Using manual review data');
      populateManualReview({
        authorName: manualAuthorName,
        reviewText: manualReviewText,
        rating: manualRating,
        reviewLink: manualReviewLink,
        authorImage: manualAuthorImage,
      });
      return;
    }

    // Otherwise try to get from _appioGoogleReviewsData
    const reviewEle = document.querySelector('.full-review');
    const reviewId = reviewEle ? reviewEle.getAttribute('data-review_id') : null;
    console.log('Looking for Review ID:', reviewId);

    if (!reviewId || reviewId === '') {
      console.log('❌ No Review ID found in section settings');
      showDefaultReview();
      return;
    }

    // Wait for _appioGoogleReviewsData to be available
    function checkDataAndInitialize() {
      if (
        typeof _appioGoogleReviewsData !== 'undefined' &&
        _appioGoogleReviewsData &&
        _appioGoogleReviewsData.reviews
      ) {
        console.log('✅ _appioGoogleReviewsData found');

        const reviews = _appioGoogleReviewsData.reviews;
        console.log('Total reviews available:', reviews.length);
        console.log(
          'All reviews:',
          reviews.map((r) => ({ id: r.id, reviewId: r.reviewId, author: r.authorName }))
        );

        // Find the specific review by ID
        const targetReview = reviews.find(
          (review) =>
            review.id == reviewId || review.reviewId === reviewId || review.id.toString() === reviewId.toString()
        );

        if (targetReview) {
          console.log('✅ Target review found:', targetReview.authorName);
          populateDynamicReview(targetReview);
        } else {
          console.log('❌ Review not found with ID:', reviewId);
          showDefaultReview();
        }
      } else {
        console.log('⏳ _appioGoogleReviewsData not available yet, retrying...');
        setTimeout(checkDataAndInitialize, 500);
      }
    }

    checkDataAndInitialize();
  }

  // Function to initialize Bootstrap popovers
  function initializePopovers() {
    // Wait for Bootstrap to be available
    if (typeof bootstrap !== 'undefined') {
      const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
      const popoverList = [...popoverTriggerList].map((popoverTriggerEl) => {
        return new bootstrap.Popover(popoverTriggerEl, {
          trigger: 'hover',
          placement: 'top',
          html: true,
          container: 'body',
          customClass: 'review-popover',
        });
      });
      console.log('✅ Popovers initialized:', popoverList.length);
    } else {
      // Retry if Bootstrap not loaded yet
      setTimeout(initializePopovers, 100);
    }
  }

  // Function to populate manual review
  function populateManualReview(manualData) {
    console.log('🎯 Populating manual review:', manualData.authorName);

    const fullReviewContainer = document.querySelector('.full-review');
    if (!fullReviewContainer) return;

    // Create star rating HTML
    function createStarRating(rating) {
      const maxStars = 5;
      const filledStars = Math.round(rating);
      const emptyStars = maxStars - filledStars;

      let starsHTML = '';

      for (let i = 0; i < filledStars; i++) {
        starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
      }

      for (let i = 0; i < emptyStars; i++) {
        starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
      }

      return `<div class="star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
    }

    // Function to truncate text to 130 characters
    function truncateText(text, maxLength = 130) {
      // Remove HTML tags for truncation
      const cleanText = text.replace(/<[^>]*>/g, '');
      if (cleanText.length <= maxLength) return cleanText;
      return cleanText.substring(0, maxLength) + '...';
    }

    const fullContent = manualData.reviewText.replace(/<[^>]*>/g, '');
    const truncatedContent = truncateText(fullContent, 130);
    const needsTruncation = fullContent.length > 130;
    const displayContent = needsTruncation ? truncatedContent : fullContent;

    const reviewHTML = `
    ${
      manualData.authorImage && manualData.authorImage !== ''
        ? `
      <div class="author_icon">
        <img 
        src="${manualData.authorImage}" 
        alt="${manualData.authorName}" 
        class="author_image"
        width="100"
        height="100"
        loading="lazy"
        onerror="this.style.display='none';" 
>
      </div>
    `
        : `
      <div class="author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
        <span style="font-size: 20px;">👤</span>
      </div>
    `
    }
    <div class="author-details">
      <div class="hide_rating_icon">
        ${createStarRating(manualData.rating || 5)}
      </div>
      ${
        displayContent
          ? `
        <div class="full-review-content">
          <p
            ${
              needsTruncation
                ? `data-bs-toggle="popover" 
                     data-bs-title="${manualData.authorName}" 
                     data-bs-content="${fullContent.replace(/"/g, '&quot;')}"`
                : ''
            }
            style="cursor: ${needsTruncation ? 'pointer' : 'default'}; margin: 0;"
          >${displayContent}</p>
        </div>
      `
          : ''
      }
      <div class="author_rating_main">
        <div class="author_rating_content">
          ${createStarRating(manualData.rating || 5)}
          <p class="author-name">${manualData.authorName || 'Happy Customer'}</p>
        </div>
        <div class="verify-info">
          ${
            manualData.reviewLink
              ? `
            <a href="${manualData.reviewLink}" target="_blank" style="text-decoration: none;">
              <span class="verify-content">Verified Customer</span>
            </a>
          `
              : `
            <span class="verify-content">Verified Customer</span>
          `
          }
        </div>
      </div>
    </div>
  `;

    fullReviewContainer.innerHTML = reviewHTML;

    // Initialize popovers after content is added
    setTimeout(initializePopovers, 100);
    console.log('✅ Manual review updated successfully');
  }

  // Function to populate dynamic review from _appioGoogleReviewsData
  function populateDynamicReview(review) {
    console.log('🎯 Populating dynamic review:', review.authorName);

    const fullReviewContainer = document.querySelector('.full-review');
    if (!fullReviewContainer) return;

    // Create star rating HTML
    function createStarRating(rating) {
      const maxStars = 5;
      const filledStars = Math.round(rating);
      const emptyStars = maxStars - filledStars;

      let starsHTML = '';

      for (let i = 0; i < filledStars; i++) {
        starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
      }

      for (let i = 0; i < emptyStars; i++) {
        starsHTML += `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CCCCCC">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      `;
      }

      return `<div class="star-rating" style="display: flex; gap: 2px; align-items: center;">${starsHTML}</div>`;
    }

    // Function to truncate text to 130 characters
    function truncateText(text, maxLength = 130) {
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    }

    const fullContent = review.originalText || '';
    const truncatedContent = truncateText(fullContent, 130);
    const needsTruncation = fullContent.length > 130;
    const displayContent = needsTruncation ? truncatedContent : fullContent;

    const reviewHTML = `
    ${
      review.authorPhotoUrl
        ? `
      <div class="author_icon">
        <img 
        src="${review.authorPhotoUrl}" 
        alt="${review.authorName}" 
        class="author_image"
        width="100"
        height="100"
        loading="lazy"
        onerror="this.style.display='none';" 
>
      </div>
    `
        : `
      <div class="author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
        <span style="font-size: 20px;">👤</span>
      </div>
    `
    }
    <div>
      <div class="hide_rating_icon">
        ${createStarRating(review.rating || 5)}
      </div>
      ${
        displayContent
          ? `
        <div class="full-review-content">
          <p
            ${
              needsTruncation
                ? `data-bs-toggle="popover" 
                     data-bs-title="${review.authorName}" 
                     data-bs-content="${fullContent.replace(/"/g, '&quot;')}"`
                : ''
            }
            style="cursor: ${needsTruncation ? 'pointer' : 'default'}; margin: 0;"
          >${displayContent}</p>
        </div>
      `
          : ''
      }
      <div class="author_rating_main">
        <div class="author_rating_content">
          ${createStarRating(review.rating || 5)}
          <p class="author-name">${review.authorName || 'Happy Customer'}</p>
        </div>
        <div class="verify-info">
          ${
            review.reviewUrl
              ? `
            <a href="${review.reviewUrl}" target="_blank" style="text-decoration: none;">
              <span class="verify-content">Verified Customer</span>
            </a>
          `
              : `
            <span class="verify-content">Verified Customer</span>
          `
          }
        </div>
      </div>
    </div>
  `;

    fullReviewContainer.innerHTML = reviewHTML;

    // Initialize popovers after content is added
    setTimeout(initializePopovers, 100);
    console.log('✅ Dynamic review updated successfully');
  }

  // Function to show default review
  function showDefaultReview() {
    const fullReviewContainer = document.querySelector('.full-review');
    if (!fullReviewContainer) return;

    fullReviewContainer.innerHTML = `
    <div class="author_icon" style="background: #f0f0f0; display: flex; align-items: center; justify-content: center;">
      <span style="font-size: 20px;">👤</span>
    </div>
    <div>
      <div class="hide_rating_icon">
        <div class="star-rating" style="display: flex; gap: 2px; align-items: center;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
      </div>
      <div class="full-review-content">
        <p>Excellent product and service!</p>
      </div>
      <div class="author_rating_main">
        <div class="author_rating_content">
          <div class="star-rating" style="display: flex; gap: 2px; align-items: center;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#FFD700" stroke="#FFD700">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
          </div>
          <p class="author-name">Happy Customer</p>
        </div>
        <div class="verify-info">
          <span class="verify-content">Verified Customer</span>
        </div>
      </div>
    </div>
  `;
  }

  // Start the process
  loadBootstrap();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navbar"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("scroll", function () {
  const menu = document.getElementById("menu");
  const header = document.getElementById("mobile-menu");

  if (window.scrollY > 150) {
    menu.classList.add("fixed-nav");
    header.classList.add("fixed-nav");
  } else {
    menu.classList.remove("fixed-nav");
    header.classList.remove("fixed-nav");
  }
});

// Open sidebar search when clicking header search
document.addEventListener("DOMContentLoaded", function () {
  const headerSearchBox = document.querySelector("#navbar-desktop .searchbox-wrapper");
  const offcanvasSearch = document.querySelector("#offcanvas-search");

  if (!headerSearchBox || !offcanvasSearch) return;

  headerSearchBox.addEventListener("click", function (e) {
    // Prevent default form focusing
    e.preventDefault();

    // Open sidebar search
    const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasSearch);
    offcanvas.show();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-03"] && !Shopify.designMode) return;
  try {
    
  /*
    Recently Viewed - Swiper Integration
*/
  const initRecentlyViewed = async () => {
    const localStorageKey = 'ecomify_recently_viewed_v1';

    // Target the Swiper wrapper
    const swiperWrapper = document.querySelector('.product-template-section-02-slider .swiper-wrapper');
    if (!swiperWrapper) {
      return;
    }

    // Clear existing slides
    swiperWrapper.innerHTML = '';

    // Get data from localStorage
    const recentlyViewed = JSON.parse(localStorage.getItem(localStorageKey)) || [];

    if (recentlyViewed.length === 0) {
      return;
    }

    // Build slides dynamically
    recentlyViewed.forEach((product) => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');

      // Ensure full image URL with https:
      const rawImg = product.featured_image
        ? product.featured_image.startsWith('//')
          ? `https:${product.featured_image}`
          : product.featured_image
        : "{{ 'no-image.gif' | asset_url }}";

      // Resize safely
      const imgSrc =
        window.Shopify && typeof Shopify.resizeImage === 'function'
          ? Shopify.resizeImage(rawImg, '300x300', 'center')
          : rawImg;

      // Format price safely
      const priceText =
        window.Shopify && typeof Shopify.formatMoney === 'function'
          ? Shopify.formatMoney(product.price)
          : `$${(product.price / 100).toFixed(2)}`;

      slide.innerHTML = `
    <div class="slide">
      <img 
        src="${imgSrc}" 
        alt="${product.title || ''}" 
        class="img-fluid"
      >
      <div class="slide-card-footer">
        <div class="flex">
          <div>
            <div class="product-category-title">${product.vendor || ''}</div>
            <div class="price">${priceText}</div>
          </div>
          <div class="ml-auto">
            <a href="${product.url}" class="btn btn-primary">View Product</a>
          </div>
        </div>
      </div>
    </div>
  `;

      swiperWrapper.appendChild(slide);
    });

    if (swiperWrapper.innerHTML) {
      console.log('Initializing Recently Viewed Swiper with slides:', swiperWrapper.innerHTML);

      /**
       * The Slider Parent Will be visiable.
       */
      document.querySelector('#product-template-section-02-recently-viewed-slider').style.display = 'block';

      // Initialize Swiper after injecting slides
      const swiper = new Swiper('.product-template-section-02-slider .swiper-container', {
        slidesPerView: 1.4, // 1 full + 0.3 visible
        spaceBetween: 20,
        navigation: {
          nextEl: '#product-template-section-02-recently-viewed-slider .swiper-button-next',
          prevEl: '#product-template-section-02-recently-viewed-slider .swiper-button-prev',
        },
         breakpoints: {
          1920: {
            slidesPerView: 1.4,
            spaceBetween: 20,
          },
          1440: {
            slidesPerView: 1.4,
            spaceBetween: 20,
          },
          1366: {
            slidesPerView: 1.4,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 1.4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 1.4,
            spaceBetween: 20,
          },
        414: {
          slidesPerView: 1,
          spaceBetween: 5,
        },
  },
      });
    } else {
      console.log('No slides to display in Recently Viewed Swiper.');
    }
  };

  // Run on load
  initRecentlyViewed();

  // Re-run on section load in Shopify editor
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.product-template-section-02-slider')) {
      initRecentlyViewed();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-section-16"] && !Shopify.designMode) return;
  try {
    
  /**
   * Initialize Swiper instance for the section
   */
  function initSpecialProductsSwiper(sectionEl) {
    const swiperContainer = sectionEl.querySelector('.special-products-section .swiper-container');

    // destroy existing swiper if already initialized
    if (swiperContainer?.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }

    return new Swiper(swiperContainer, {
      slidesPerView: 3.5,
      spaceBetween: 20,
      navigation: {
        nextEl: sectionEl.querySelector('.special-products-section .swiper-button-next'),
        prevEl: sectionEl.querySelector('.special-products-section .swiper-button-prev'),
      },
      breakpoints: {
         1920: {
           slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1440: {
           slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1366: {
           slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1280: {
           slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1024: {
           slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
           slidesPerView: 1.5,
            spaceBetween: 20,
          },
        414: {
          slidesPerView: 1,
          spaceBetween: 15,
        },
      },
    });
  }

  /**
   * Fetch and inject recommended products
   */
  async function initRecommendedProducts(sectionEl) {
    if (!sectionEl) return;

    const { sectionId, baseUrl, productId, limit, intent } = sectionEl.dataset;
    const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`;

    try {
      const response = await fetch(url);
      const html = await response.text();

      // Replace section content
      sectionEl.closest('.shopify-section').outerHTML = html;

      const newSection = document.getElementById(`product-section-16-special-products-${sectionId}`);

      // Initialize swiper on the new DOM
      initSpecialProductsSwiper(newSection);

      // Dispatch custom event (optional hook for other scripts)
      window.dispatchEvent(new CustomEvent('init.ecomify.recommended_products'));
    } catch (err) {
      console.error('Failed to load recommendations', err);
    }
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    const sectionEl = document.querySelector('.product-section-16-special-products');
    if (sectionEl) {
      initRecommendedProducts(sectionEl);
    }
  });

  // Theme editor reload
  document.addEventListener('shopify:section:load', (e) => {
    const sectionEl = e.target.querySelector('.product-section-16-special-products');
    if (sectionEl) {
      initRecommendedProducts(sectionEl);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
